import { useState } from 'react';
import { Entity, /*SystemEntity*/ } from '@backstage/catalog-model';
import { ApiEntity } from '@backstage/catalog-model';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { TableColumn } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import Typography from '@material-ui/core/Typography';
import { InfoCard, Progress, ResponseErrorPanel } from '@backstage/core-components';
import { useFilteredEntityChildren } from '../Hooks'
import { ApiTypeTitle, ApiDefinitionDialog } from '@backstage/plugin-api-docs';
import ExtensionIcon from '@mui/icons-material/Extension';
import ToggleButton from '@material-ui/lab/ToggleButton';

export function createSpecApiTypeColumn(): TableColumn<ApiEntity> {
  return {
    title: 'Type',
    field: 'spec.type',
    render: entity => <ApiTypeTitle apiEntity={entity} />,
  };
}

function createApiDefinitionColumn(): TableColumn<ApiEntity> {
  return {
    title: 'API Definition',
    render: entity => <ApiDefinitionButton apiEntity={entity} />,
  };
}


const ApiDefinitionButton = ({ apiEntity }: { apiEntity: ApiEntity }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <ToggleButton
        aria-label="Toggle API Definition Dialog"
        onClick={() => setDialogOpen(!dialogOpen)}
        value={dialogOpen}
      >
        <ExtensionIcon />
      </ToggleButton>
      <ApiDefinitionDialog
        entity={apiEntity}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};


const entityColumns: TableColumn<ApiEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'API' }),
    EntityTable.columns.createOwnerColumn(),
    createSpecApiTypeColumn(),
    EntityTable.columns.createSpecLifecycleColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
    createApiDefinitionColumn(),
  ];



export function ProvidedApiTable() {
    const { loading, error, value }  = useFilteredEntityChildren( (entity: Entity) => entity.kind === 'API');    
    const { entity } = useEntity<Entity>();

    const title="Provides APIs";
    const variant="gridItem"

    if (loading) {
        return (
            <InfoCard variant={variant} title={title}>
                <Progress />
            </InfoCard>
        );
    }

    if (error) {
        return (
            <InfoCard variant={variant} title={title}>
            <ResponseErrorPanel error={error} />
            </InfoCard>
        );
    }

    return (
        <EntityTable
            title={title}
            variant={variant}
            emptyContent={
            <div style={{ textAlign: 'center' }}>
                <Typography variant="body1">
                    {entity.metadata.title ? entity.metadata.title : entity.metadata.name} does not provide any APIs
                </Typography>
            </div>
            }
            columns={entityColumns}
            entities={value as ApiEntity[]}
      />
    )
};
